module.exports = __webpack_public_path__ + "img/ic_launcher.65c34f98.png";